/**
 * Estados del control de muebles, iguales a las constantes de CustomerFurniture.
 *
 * Viven acá y no en cada pantalla para que agregar uno sea tocar un solo
 * archivo: el listado, el detalle, el filtro y el modal leen de esta lista.
 * Qué significa cada uno está documentado en el modelo, no acá.
 */
export const ESTADOS = [
  { id: 'A', descripcion: 'Alta' },
  { id: 'B', descripcion: 'Baja' }
];

/** El único con el mueble puesto en la tienda: ESTADOS_VIGENTES del modelo. */
export const ESTADOS_VIGENTES = ['A'];

/** Nombre del estado. Si llega uno que no conocemos se muestra el código crudo. */
export const nombreEstado = (id) => ESTADOS.find((e) => e.id === id)?.descripcion || id || '';
